<template>
  <van-checkbox-group v-model="itemValue" @change="onValueChange()">
    <van-checkbox
      v-for="(optionItem, index) in optionList"
      :key="index" 
      class="checkbox-item"
      shape="square"
      :name="optionItem.id"
      :checked-color="themeColor"
      :disabled="isDisabledOpt(optionItem) || readonly"
      @click="onOptionClick(optionItem, $event)"
    >
      <div class="title-wrap">
        <div class="left">{{ optionItem.name }}</div>
        <div class="right" v-if="readonly && submitOptionResByItem">
          <span class="r-text" :class="{'active': itemValue.indexOf(optionItem.id) >= 0}">{{ submitOptionResByItem[optionItem.id] }}票</span>
          <span class="r-text" :class="{'active': itemValue.indexOf(optionItem.id) >= 0}">{{ $filters.formatPercent(submitOptionResByItem[optionItem.id] / submitOptionResByItem.total) }}</span>
        </div>
      </div>
      <van-progress 
        v-if="readonly && submitOptionResByItem"
        class="progress"
        :percentage="submitOptionResByItem.total ? Math.floor((submitOptionResByItem[optionItem.id] / submitOptionResByItem.total) * 100) : 0"
        :show-pivot="false"
        :color="themeColor"
        stroke-width="1px"
      />
      <div 
        class="img-wrap" 
        v-if="optionItem.img && !readonly"
        @click.stop="imgClick(optionItem)">
        <img 
          class="img" 
          :src="optionItem.img"
        />
        <div class="icon-wrap">
          <img 
            class="icon" 
            src="https://stor.weixinhost.com/3/wxhost-images/rf_77a9fca7071c70e5c9f9811755303614" 
          />
        </div>
      </div>
      <SpecialValueInput 
        v-if="showOtherInput(optionItem)"
        v-model="specialValue"
        :disabled="readonly"
        @change="onValueChange()"
        @click.stop
      />
    </van-checkbox>
  </van-checkbox-group>
</template>

<script>
import _ from 'lodash';
import SpecialValueInput from '../comps/SpecialValueInput.vue';
import { Checkbox, CheckboxGroup, ImagePreview, Progress } from 'vant';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      specialValue: null
    };
  },
  computed: {
    submitOptionResByItem() {
      return this.$store.state.submitOptionRes[this.item.id] || null;
    },
    optionList() {
      let opArr = [];
      const specialArr = [];
      this.item.option?.map(v => {
        if (v.special) {
          specialArr.push(v);
        } else {
          opArr.push(v);
        }
      });
      if (this.item.random) {
        opArr = _.shuffle(opArr);
      }
      return _.concat(opArr, specialArr);
    },
    checkAll() {
      const allIndex  = this.optionList.findIndex(v => this.itemValue.indexOf(v.id) >= 0 && v.special === 'all');
      return allIndex >= 0;
    },
    themeColor() {
      return this.$store.state.formConfig.theme_color;
    },
  },
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Progress.name]: Progress,
    SpecialValueInput
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      let tmpArr = [];
      
      this.submitValue?.value?.map(v => {
        const index = this.optionList.findIndex(v2 => v2.id === v);
        if (index >= 0) {
          tmpArr.push(v);
        }
      });
      this.itemValue = tmpArr;
      this.specialValue = this.submitValue?.special_value || '';
    },
    // 【2】值监听
    onValueChange() {

      const otherIndex  = this.optionList.findIndex(v => this.itemValue.indexOf(v.id) >= 0 && v.special === 'other');
      this.$emit('change', otherIndex >= 0 ? {
        value: this.itemValue,
        special_value: this.specialValue
      } : { value: this.itemValue });
    },
    showOtherInput(optionItem) {
      return optionItem.special === 'other' && this.itemValue.indexOf(optionItem.id) >= 0;
    },
    onOptionClick(optionItem, e) {
      const isCheck = this.itemValue.indexOf(optionItem.id) >= 0;
      if (optionItem.special === 'all' && isCheck) {
        this.itemValue = [optionItem.id];
      }
      else if (optionItem.special !== 'all' && isCheck) {
        const allIndex = this.itemValue.findIndex(v => {
          const index = this.optionList.findIndex(v2 => v === v2.id && v2.special === 'all');
          return index >= 0;
        });
        if (allIndex >= 0) {
          this.itemValue.splice(allIndex, 1);
        }
      }
    },
    imgClick(optionItem) {
      ImagePreview([optionItem.img]);
    },
    isDisabledOpt(optionItem) {
      if (this.item?.limit_count?.max) {
        if (this.itemValue.length >= this.item.limit_count.max) {
          const index = this.itemValue.findIndex(v => v === optionItem.id);
          if (index < 0) {
            return true;
          }
        }
      }
      return false;
      
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.checkbox-item {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  .img-wrap {
    .img-wrap();
    margin-top: 12px;
  }
  /deep/ .van-checkbox__label {
    flex: 1;
    min-width: 0;
    .form-item-text-1();
  }
  .progress {
    margin-top: 6px;
  }
  .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      min-width: 0;
      overflow-wrap: anywhere;
    }
    .right {
      flex-shrink: 0;
      text-align: right;
    }
    .r-text {
      margin-left: 9px;
      color: @desc-color-2;
      &.active {
        color: var(--theme-main-color);
      }
    }
  }
}
</style>
